var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_5879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.662 8.66197L14.1425 10.9823C14.1927 11.0157 14.251 11.0348 14.3112 11.0377C14.3714 11.0406 14.4313 11.0271 14.4844 10.9987C14.5375 10.9702 14.582 10.9279 14.6129 10.8762C14.6439 10.8245 14.6603 10.7654 14.6603 10.7051V5.24344C14.6603 5.18482 14.6449 5.12723 14.6155 5.07648C14.5862 5.02574 14.5439 4.98364 14.4931 4.95444C14.4423 4.92523 14.3846 4.90996 14.326 4.91016C14.2674 4.91036 14.2098 4.92602 14.1592 4.95557L10.662 6.99602",
    stroke: "#D1D5DC",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32931 3.99805H2.66552C1.92946 3.99805 1.33276 4.59474 1.33276 5.33081V10.6618C1.33276 11.3979 1.92946 11.9946 2.66552 11.9946H9.32931C10.0654 11.9946 10.6621 11.3979 10.6621 10.6618V5.33081C10.6621 4.59474 10.0654 3.99805 9.32931 3.99805Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_5879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9931,
    height: 15.9931,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.d8cd3a77d5c38d3a5d5ddf3133834287.svg";
export { ForwardRef as ReactComponent };